import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-red px-4 py-24 text-center text-white" data-id="element-260">
      <Reveal className="mx-auto max-w-3xl" data-id="element-261">
        <h2 className="text-4xl font-black md:text-5xl" data-id="element-262">
          Ready to Get Your Time Back?
        </h2>
        <CTAButton variant="white" className="mt-9 px-10 py-5 text-lg" data-id="element-263">
          GET THE ART READY PACK
        </CTAButton>
      </Reveal>
    </section>;
}